export default __webpack_public_path__ + "static/media/Negro-logo-contratos-tren-maya.bc80a2a6.svg";